// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"HomeLogo_logoContainer__12qhs","logo":"HomeLogo_logo__13f_P"};